import { TablePage } from "~/components/Table";
import { LqsNavigation } from "~/lqs";
import { WorkflowFilters } from "./components/WorkflowFilters";
import {
  WorkflowSearchRequestProvider,
  WorkflowTable,
} from "./components/WorkflowTable";

export function WorkflowsPage() {
  return (
    <TablePage
      title="Search Workflows"
      navigation={<LqsNavigation />}
      RequestProvider={WorkflowSearchRequestProvider}
      table={<WorkflowTable />}
      filters={<WorkflowFilters />}
    />
  );
}
